import React from 'react';
import { MapPin, Calendar, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const QuickActions = () => {
  const openMaps = () => {
    window.open('https://www.google.com/maps/search/?api=1&query=Kyle+Rise+Car+Park+Ayr', '_blank');
  };

  const scrollToBooking = () => {
    if (window.location.pathname === '/young-drivers') {
      document.getElementById('book')?.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    if (window.location.pathname !== '/') {
      window.location.href = '/#book';
      return;
    }

    document.getElementById('book')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const actions = [
    {
      icon: <MapPin className="w-8 h-8" />,
      title: 'Find Us',
      description: 'Kyle Rise Car Park, Ayr',
      action: openMaps,
      buttonText: 'Get Directions',
      gradient: 'from-purple-500 to-pink-500',
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      title: 'Sessions Available',
      description: 'Book your preferred time',
      action: scrollToBooking,
      buttonText: 'View Calendar',
      gradient: 'from-blue-500 to-cyan-500',
    },
    {
      icon: <MessageCircle className="w-8 h-8" />,
      title: 'Questions?',
      description: 'Get in touch with us',
      action: scrollToContact,
      buttonText: 'Contact Us',
      gradient: 'from-orange-500 to-red-500',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-6">
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={action.action}
              className="group bg-white rounded-2xl p-6 shadow-lg border-2 border-gray-200 hover:border-[hsl(210,100%,45%)] hover:shadow-xl transition-all duration-300 text-left cursor-pointer"
            >
              <div className={`inline-flex p-4 rounded-xl bg-gradient-to-br ${action.gradient} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <div className="text-white">{action.icon}</div>
              </div>
              <h3 className="text-xl font-bold text-[hsl(210,100%,12%)] mb-2 group-hover:text-[hsl(210,100%,45%)] transition-colors">
                {action.title}
              </h3>
              <p className="text-gray-600 mb-4">{action.description}</p>
              <Button
                size="sm"
                className="w-full bg-gradient-to-r from-[hsl(210,100%,45%)] to-[hsl(180,80%,45%)] hover:from-[hsl(210,100%,40%)] hover:to-[hsl(180,80%,40%)] text-white font-semibold"
              >
                {action.buttonText}
              </Button>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickActions;